import { GET_DATA_PLANHANDLE_STEP_SUCCEEDED, REQUERT_PLANHANDLE_STEP_FAILED } from "../actions/actionTypes";

const RejectPageReducer = (DataPlanStep = [], actions) => {
    switch (actions.type) {
        case GET_DATA_PLANHANDLE_STEP_SUCCEEDED:
            if(Object.keys(actions.DataPlanStep).length > 0)
            {
                return {...DataPlanStep,DataPlanStep: actions.DataPlanStep};
            }
            else
            {
                return {...DataPlanStep,DataPlanStep: []};
            }
        case REQUERT_PLANHANDLE_STEP_FAILED:
            return {...DataPlanStep,DataPlanStep: []};
        default:
            return DataPlanStep;
    }
}
export default RejectPageReducer;